import styled from 'styled-components';
import {
  attachLocale,
  switchLocale,
  trackAnalytics,
} from '../../../../lib/utils';
import {
  CATEGORIES_DROPDOWN,
  DOM_SITEMAP_LINKS_SECTION,
  LANGUAGE_SWITCH,
  PAGE_DIRECTORY,
} from '../../../../lib/constants';
import { SiteMapAnchor } from './sitemap.shared';

const SiteMapLinksGroup = (props) => {
  const {
    footerLinkData = {},
    locale = 'en',
    urlData = {},
  } = props;

  const pathname = urlData && urlData.pathname ?
    urlData.pathname :
    '';

  const {
    name = '',
    displayName = '',
    text = '',
    descriptiveText,
    url = '',
    tags = {},
    navSlotPurpose = '',
  } = footerLinkData;

  const resolvedLocaleLink = navSlotPurpose === LANGUAGE_SWITCH ?
    switchLocale(pathname.replace(/\//, ''), url) :
    attachLocale(url, locale);

  const track = trackAnalytics(DOM_SITEMAP_LINKS_SECTION, `SiteMapLinksGroup-${url}`, resolvedLocaleLink, tags);

  if (navSlotPurpose === CATEGORIES_DROPDOWN) {
    const regex = new RegExp(url);
    const trackToUse = track.url.replace(regex, PAGE_DIRECTORY);
    track.url = `${trackToUse}#${url}`;
  }

  return (
    <SiteMapAnchor
      key={`sitemap-link-${url}`}
      href={track.url}
      data-track-id={track.dataTrackingId}
      data-track-click={track.dataTrack}
      aria-label={descriptiveText}>
      {text || displayName || name}
    </SiteMapAnchor>
  );
};

export default SiteMapLinksGroup;
